import React from 'react'
import PT from 'prop-types'
import Button from '@vimcar/shared-components/components/Button'
import Card from '@vimcar/shared-components/components/Card'
import CardHeader from '@vimcar/shared-components/components/CardHeader'
import CardContent from '@vimcar/shared-components/components/CardContent'
import Grid from '@vimcar/shared-components/components/Grid'
import GridItem from '@vimcar/shared-components/components/GridItem'
import TextField from '@vimcar/shared-components/components/TextField'
import linkStore from '@vimcar/shared-utils/linkStore'

import i18n from '#utils/i18n'
import EditEmailDialog from '#components/EditEmailDialog'
import EditPasswordDialog from '#components/EditPasswordDialog'
import mkStore from './store'
import styles from './styles.css'

const tp = i18n.prefix('components.ProfilePreferences')

const ProfileSecurity = ({ store }) => (
  <Card>
    <CardHeader title={tp('title')}/>
    <CardContent>
      <TextField
        disabled
        classNameInner={styles.input}
        floatingLabelText={tp('email')}
        value={store.email}
        />

      {store.showEditEmail && (
        <EditEmailDialog onClose={store.handleCloseDialog}/>
      )}

      {store.showEditPassword && (
        <EditPasswordDialog onClose={store.handleCloseDialog}/>
      )}

      <Grid>
        <GridItem
          className={styles.gridItem}
          sm={{ span: 6 }}
          >
          <Button
            fullWidth
            raised
            onClick={store.handleClickEditEmail}
            >
            {tp('edit-email')}
          </Button>
        </GridItem>
        <GridItem
          className={styles.gridItem}
          sm={{ span: 6 }}
          >
          <Button
            fullWidth
            raised
            onClick={store.handleClickEditPassword}
            >
            {tp('edit-password')}
          </Button>
        </GridItem>
      </Grid>
    </CardContent>
  </Card>
)

ProfileSecurity.propTypes = {
  store: PT.object.isRequired,
}

export default linkStore(mkStore, ProfileSecurity)
